import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { motion, AnimatePresence } from "framer-motion";
import "./Valentine2026.css";

const noHoverMessages = [
  "Are you sure? 😢",
  "Really? 💔",
  "Think again...",
  "Yes is this way →",
  "You know you want to say Yes 💖",
];

// Items: photos + empty spacers for randomized staggering
const leftItems = [
  { type: "spacer", height: 60 },
  { type: "photo", src: "IMG_9501.PNG", rotate: -6 },
  { type: "photo", src: "IMG_9503.PNG", rotate: 4 },
  { type: "spacer", height: 100 },
  { type: "photo", src: "IMG_9505.PNG", rotate: -3 },
  { type: "spacer", height: 40 },
  { type: "photo", src: "IMG_9508.PNG", rotate: 5 },
  { type: "photo", src: "IMG_9512.PNG", rotate: -4 },
  { type: "spacer", height: 80 },
];

const rightItems = [
  { type: "photo", src: "IMG_9502.PNG", rotate: 5 },
  { type: "spacer", height: 90 },
  { type: "photo", src: "IMG_9504.PNG", rotate: -7 },
  { type: "photo", src: "IMG_9506.PNG", rotate: 6 },
  { type: "spacer", height: 70 },
  { type: "photo", src: "IMG_9509.PNG", rotate: -5 },
  { type: "spacer", height: 50 },
];

// Combined list for mobile — all photos from both columns, no spacers
const allPhotos = [
  ...leftItems.filter((i) => i.type === "photo"),
  ...rightItems.filter((i) => i.type === "photo"),
];

const Valentine2026 = () => {
  const navigate = useNavigate();
  const [noScale, setNoScale] = useState(1);
  const [yesScale, setYesScale] = useState(1);
  const [noHovered, setNoHovered] = useState(false);
  const [cycleIndex, setCycleIndex] = useState(0);

  useEffect(() => {
    if (!noHovered) return;
    const id = setInterval(() => {
      setCycleIndex((i) => (i + 1) % noHoverMessages.length);
    }, 1800);
    return () => clearInterval(id);
  }, [noHovered]);

  const handleNo = () => {
    setNoScale((prev) => Math.max(prev * 0.6, 0.15));
    setYesScale((prev) => prev * 1.2);
  };

  return (
    <div className="v26-container">
      <button className="v26-back-btn" onClick={() => navigate("/")}>
        ← view other years
      </button>

      <div className="v26-layout">
        {/* Left image column */}
        <div className="v26-col v26-col-left">
          {leftItems.map((item, i) =>
            item.type === "spacer" ? (
              <div key={`ls-${i}`} style={{ height: item.height }} />
            ) : (
              <motion.div
                key={item.src}
                className="v26-margin-photo"
                initial={{ opacity: 0, scale: 0.9, rotate: item.rotate }}
                animate={{ opacity: 1, scale: 1, rotate: item.rotate }}
                transition={{ delay: 0.3 + i * 0.1, duration: 0.5 }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/2026Images/${item.src}`}
                  alt=""
                  className="v26-margin-img"
                  loading="lazy"
                />
              </motion.div>
            )
          )}
        </div>

        {/* Center text column */}
        <motion.div
          className="v26-col v26-col-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h1 className="v26-title">Valentine's Day 2026</h1>

          <div className="v26-letter">
            <p className="v26-greeting">Hi baby,</p>

            <p className="v26-paragraph">
              You are in Vietnam for valentines day this year, but so I thought
              I'd bring valentines day to you using the method I developed last
              year — I want to make this a yearly tradition with its unique
              twist every year. It's currently Jan‑3rd‑2026, I'm in Portland
              with my family and it's been a week since we have found each other
              again. I've been so fucking scared, my heart is completely in,
              opened, and so the potential for damage is so high. Even though we
              have promised exclusivity, I can't help but have my fears. This
              morning though, you sent me a text that made me feel at such ease:
            </p>

            <div className="v26-photo-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/2026Image.png`}
                alt="screenshot"
                className="v26-photo"
              />
            </div>

            <p className="v26-paragraph">
              You are at work right now, but you sent me that message just
              before your shift and I keep reading it and feel a sense of warmth
              and relief take over my body. (Thank god you work a retirement
              home at least I have no one to worry about there unless ur into
              seniors LOL). My guard is now completely down, and I am so damn
              sure we will make this work. Which is why I am writing this
              message for valentines day insanely early. Maybe I'm foolish to
              have such confidence, but I know you better than I know anyone,
              and I know when your heart is with me. I also know us, we have
              worked through some of the hardest of times. Life has not been
              kind to our relationship, we somehow bring out the worst and best
              in each other but we have worked through it every time. We know
              each other like no other lovers do, we feel deeper than anyone
              else, so if anyone can do it it's us. I truly believe that things
              happen for a reason, and I think that this last period of hardship
              was necessary for us to find eternal peace. I feel so much more
              like myself, and you are finally taking good care of yourself,
              building a social life, and achieving consistency. We now both
              understand the value of living individual lives and have developed
              the skills to do that better. I've shifted my views on things like
              alcohol that used to be a point of conflict for us, but most
              important of all, my parents are in. They support a marriage
              between us and god that makes me so excited. I can't wait to
              slowly involve you in my family as we build trust again.
            </p>

            <p className="v26-paragraph">
              The look of pure joy on your face this week is an image that won't
              leave my head, god it makes me so happy to see you be happy. It's
              so beautiful that your smile is coming from within your soul, the
              joy is so deep. My life feels complete when I see you smile like
              this. New Year's Eve was also a lot of fun, and it's when you told
              me that we can potentially be publicly back together by the
              summer. Do you remember the state we were in while you wished me a
              happy 20th birthday? ;)
            </p>

            <p className="v26-paragraph">
              I am so in over my head, so committed, and so hopeful — and if you
              are reading this on valentines day then I guess the following
              message won't matter but for now — please, tell me you are the
              Stacey I know and trust, and you aren't just playing me because
              you miss my company. Because if that's the case, my entire
              prescription of love, and trust will be dismantled. You are the
              one that made me believe that love is real, so please, don't break
              that belief down.
            </p>

            <p className="v26-paragraph">
              With all of this being said, I am so grateful that I get to love
              you like this for ages to come. I have a lot of regret for how
              bitter everything was near November, and to see this soft side of
              both of us work so well together makes me excited to love you with
              all of my heart, it's everything you deserve. Just promise me that
              you'll keep up your end of the bargain, you'll keep taking care of
              yourself, going out with your friends, and building up your own,
              happy social life. I'm so happy to have found someone who is a
              lover, someone who isn't shallow or after chasing shallow joys. I
              love you baby.
            </p>

            <p className="v26-paragraph">
              God, just imagine the story we will tell our kids and
              grandchildren one day. A truly "movie‑like" story that will ensure
              our kids grow up believing in love, authenticity, and having a
              pure heart. I do know that things aren't easy right now, you are
              probably facing a lot of internal conflict, but I just want you to
              know that I know we'll make it. And even if we don't, I want you
              to know that as long as you stay respectful, I can't ever blame
              you or not love you. I'll always be rooting for your success.
            </p>

            <p className="v26-paragraph">
              Anyway, I thought it would be sweet for you to read my thoughts a
              week into finding each other again in a month from now. So I want
              to ask you baby, will you be my Valentine this year?
            </p>

            <p className="v26-signoff">
              I love you,
              <br />
              Ali
            </p>
          </div>
        </motion.div>

        {/* Right image column — desktop only */}
        <div className="v26-col v26-col-right v26-desktop-only">
          {rightItems.map((item, i) =>
            item.type === "spacer" ? (
              <div key={`rs-${i}`} style={{ height: item.height }} />
            ) : (
              <motion.div
                key={item.src}
                className="v26-margin-photo"
                initial={{ opacity: 0, scale: 0.9, rotate: item.rotate }}
                animate={{ opacity: 1, scale: 1, rotate: item.rotate }}
                transition={{ delay: 0.4 + i * 0.1, duration: 0.5 }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/2026Images/${item.src}`}
                  alt=""
                  className="v26-margin-img"
                  loading="lazy"
                />
              </motion.div>
            )
          )}
        </div>

        {/* Mobile-only: single column with ALL images */}
        <div className="v26-col v26-col-right v26-mobile-only">
          {allPhotos.map((item, i) => (
            <motion.div
              key={`m-${item.src}`}
              className="v26-margin-photo"
              initial={{ opacity: 0, scale: 0.9, rotate: item.rotate }}
              animate={{ opacity: 1, scale: 1, rotate: item.rotate }}
              transition={{ delay: 0.3 + i * 0.08, duration: 0.5 }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/2026Images/${item.src}`}
                alt=""
                className="v26-margin-img"
                loading="lazy"
              />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Valentine question */}
      <motion.div
        className="v26-question-container"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="v26-question-glow" />
        <h2 className="v26-question-title">Will you be my Valentine?</h2>
        <p className="v26-question-sub">
          {noHovered ? (
            <AnimatePresence mode="wait">
              <motion.span
                key={cycleIndex}
                initial={{ opacity: 0, y: 4 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -4 }}
                transition={{ duration: 0.2 }}
                style={{ display: "inline-block" }}
              >
                {noHoverMessages[cycleIndex]}
              </motion.span>
            </AnimatePresence>
          ) : (
            "You know the right answer 💕"
          )}
        </p>
        <div
          className="v26-question-btns"
          onMouseEnter={() => setNoHovered(true)}
          onMouseLeave={() => { setNoHovered(false); setCycleIndex(0); }}
        >
          <motion.button
            key="yes"
            className="v26-btn v26-btn-yes"
            animate={{ scale: yesScale }}
            whileHover={{ scale: yesScale * 1.08 }}
            whileTap={{ scale: yesScale * 0.95 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            onClick={() => navigate("/2026/sheSaidYes")}
          >
            Yes 💖
          </motion.button>
          <motion.button
            key="no"
            className="v26-btn v26-btn-no"
            animate={{ scale: noScale }}
            whileHover={{ scale: noScale * 1.05 }}
            whileTap={{ scale: noScale * 0.95 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            onClick={handleNo}
          >
            No
          </motion.button>
        </div>
        <AnimatePresence>
          {noScale < 0.5 && (
            <motion.p
              className="v26-question-hint"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
            >
              That button seems to be shrinking… 🤔
            </motion.p>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default Valentine2026;
